export const QBX_LEVEL_COUNT_VALUE = 62000

export const OPEN_SEA_BASE_URL = 'https://opensea.io/'
export const GET_KEYS_ON_OPEN_SEA_URL = `${OPEN_SEA_BASE_URL}collection/qbx-genesis-nft`
export const GET_KEYS_ON_BLUR_URL =
  'https://blur.io/eth/collection/qbx-genesis-nft'

export const TIER_STAKING_REWARD = {
  1: 0,
  2: 4,
  3: 6,
  4: 8,
  5: 10,
  6: 12
}

export const GET_QBX_PRICE_URL =
  'https://json.qiibeefoundation.org/qbx-price.json'

export const LOCK_TIME = 4320 // hours - 180 days

export const QBX_PRICE_REFRESH_TIME = 300 // seconds / 5 minutes
